import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { aiAssistantEditorContext } from '../../../../state/AIAssistantEditorProvider';
import { getCurrentConversationId } from '../../../../reducers/aiAssistant.selectors';
import services from '../../../../services';
import { downloadAudio } from '../utils';

// Podcast audio download with export tracking, shared by the desktop top bar and mobile header.
const usePodcastAudioDownload = () => {
  const { podcastDetails } = useContext(aiAssistantEditorContext);
  const currentConversationId = useSelector(getCurrentConversationId);

  const isAudioDownloadDisabled =
    !podcastDetails?.audioUrl || Boolean(podcastDetails?.audioGenerationFailed);

  const handleAudioDownload = () => {
    if (!podcastDetails?.audioUrl) return;
    // downloadAudio never rejects, so "download started" is the tracking point.
    void downloadAudio(podcastDetails.audioUrl, podcastDetails.title);
    if (!currentConversationId) return;
    services.track.ampliTrackTextEditorFileExportedEvent({
      conversationId: currentConversationId,
      exportType: 'download',
      exportFormat: 'wav',
      feature: ['podcast generation'],
    });
  };

  return { handleAudioDownload, isAudioDownloadDisabled };
};

export default usePodcastAudioDownload;
